/**
 *
 * Registered Nurse with Passed NCLEX
 * Registered Nurse NOT Passed NCLEX
 * Medical Technologist
 * Nurse Aid
 * Pharmacist
 * Physical Therapy
 * Therapy
 * Rad Tech
 * Respiratory Therapist
 * Vet
 * Others
 */
export const PROFILE_KINDS = {
	REGISTERED_NURSE_PASSED_NCLEX: 'registered_nurse_with_passed_nclex',
	REGISTERED_NURSE_NOT_PASSED_NCLEX: 'registered_nurse_not_passed_nclex',
	MEDICAL_TECHNOLOGIST: 'medical_technologist',
	NURSE_AID: 'nurse_aid',
	PHARMACIST: 'pharmacist',
	PHYSICAL_THERAPY: 'physical_therapy',
	THERAPY: 'therapy',
	RAD_TECH: 'rad_tech',
	RESPIRATORY_THERAPIST: 'respiratory_therapist',
	VET: 'vet',
	OTHERS: 'others',
	OCCUPATIONAL_THERAPY: 'occupational_therapy',
}

export const PROFILE_COMPLETION_FIELDS_NAME = {
	COUNTRY: 'country',
	COUNTRY_OF_BIRTH: 'country_of_birth',
	DISCIPLINE: 'discipline',
	SPECIALTY: 'specialty',
	RESUME: 'resume',
	NCLEX_TEST_DATE: 'nclex_test_date',
	NCLEX_STATE: 'nclex_state',
	BESIDE: 'beside',
	YEAR_IN_CURRENT_UNIT: 'year_in_current_unit',
	BACK_TO_BEDSIDE_NURSING: 'back_to_bedside_nursing',
	YEARS_OF_TOTAL_EXPERIENCE: 'years_of_total_experience',
	EDUCATION_LEVEL: 'education_level',
	COUNTRY_OF_ORIGINAL_LICENSE: 'country_of_original_license',
	DATE_OF_ORIGINAL_LICENSE: 'date_of_original_license',
	HAS_FOREIGN_NURSE_LICENSE: 'has_foreign_nurse_license',
	OTHER_NURSE_LICENSE_COUNTRIES: 'other_nurse_license_countries',
	REFER_RELOCATION_STATES: 'refer_relocation_states',
	PHONE: 'phone',
	WHATSAPP_PHONE: 'whatsapp_phone',
	VISITED_US: 'visited_us',
	VISA_TYPE_VISITED: 'visa_type_visited',
	UNLAWFUL_STATUS: 'unlawful_status',
	NEEDS_SPONSORSHIP: 'needs_sponsorship',
	VISA_TYPE: 'visa_type',
	VISA_EXPIRATION_DATE: 'visa_expiration_date',
	EMPLOYMENT_PETITION_FILED: 'employment_petition_filed',
	HAVE_PLAN_OPT: 'have_plan_opt',
	EXPECTED_OPT_DATE: 'expected_opt_date',
	PRIORITY_DATE: 'priority_date',
	SCHEDULED_EXAM: 'scheduled_exam',
	SCHEDULED_DATE: 'scheduled_date',
	HAS_ATT: 'has_att',
	ATT_EXPIRATION_DATE: 'att_expiration_date',
	HAS_BSC_MEDICAL_LAB: 'has_bsc_medical_lab',
	HAS_AMT_OT_ASCP_CERTIFICATION: 'has_amt_ot_ascp_certification',
	AMT_OR_ASCP_ATTACHMENT: 'amt_or_ascp_attachment',
	HAS_STARTED_VISA_SCREENING: 'has_started_visa_screening',
	VISA_SCREENING_OR_ENGLISH_EXAM_DOCUMENT: 'visa_screening_or_english_exam_document',
	HAS_FPGC: 'has_fpgc',
	HAS_NPTE: 'has_npte',
	HAS_PTAL: 'has_ptal',
	HAS_NBCOT: 'has_nbcot',
	PROFESSION: 'profession',
	SCHOOL_NAME: 'school_name',
	EXAM_PASS_YEAR: 'exam_pass_year',
}

export const QUESTION_TYPES = {
	SELECT: 'select',
	FILE: 'file',
	FILES: 'files',
	DATE_PICKER: 'date_picker',
	RADIO: 'radio',
	NUMBER: 'number',
	MULTI_SELECT: 'multi_select',
	TEXT: 'text',
	MULTI_MULTI_SELECT: 'multi_multi_select',
	COUNTRIES: 'countries',
	CHECKBOX: 'checkbox',
}

export const QUESTION_OPTIONS = {
	COUNTRIES: 'countries',
	DISCIPLINES: 'disciplines',
	SPECIALTIES: 'specialties',
	NCLEX_STATES: 'nclex_states', // @deprecated
	YES_NO: 'yes/no',
	EDUCATION_LEVELS: 'education_levels',
	STATE_MASTER: 'state_master',
	VISA_TYPES: 'visa_types',
	YES_NO_NOT_YET: 'yes/no/not_yet',
}

export const QUIZ_STATES = {
	ANSWERED: 'answered', // answered form
	ANSWERING: 'answering', // current form
	ABORTED: 'aborted', // The question is answered but the user has back to the previous question, the FE no need to care about
}

export const QUIZ_NAMES = {
	NURSE_GENERAL: 'nurse_general',
	NURSE_LICENSE: 'nurse_license',
	NURSE_EXPERIENCE: 'nurse_experience',
	NURSE_RELOCATION: 'nurse_relocation',
	NURSE_IN_US: 'nurse_in_us',

	NURSE_GENERAL_WITHOUT_NCLEX: 'nurse_general_without_nclex',
	NURSE_LICENSE_WITHOUT_NCLEX: 'nurse_license_without_nclex',
	NURSE_EXPERIENCE_WITHOUT_NCLEX: 'nurse_experience_without_nclex',
	NURSE_RELOCATION_WITHOUT_NCLEX: 'nurse_relocation_without_nclex',
	NURSE_IN_US_WITHOUT_NCLEX: 'nurse_in_us_without_nclex',

	MEDICAL_TECHNOLOGIST_GENERAL: 'medical_technologist_general',
	MEDICAL_TECHNOLOGIST_EXPERIENCE: 'medical_technologist_experience',
	MEDICAL_TECHNOLOGIST_CONTACT: 'medical_technologist_contact',

	NURSE_AID_GENERAL: 'nurse-aid_general',
	NURSE_AID_CONTACT: 'nurse-aid_contact',

	PHARMACIST_GENERAL: 'pharmacist_general',
	PHARMACIST_EDU: 'pharmacist_edu',

	PHYSICAL_THERAPY_GENERAL: 'physical_therapy_general',
	PHYSICAL_THERAPY_EDU: 'physical_therapy_general',

	OCCUPATIONAL_THERAPY_GENERAL: 'occupational_therapy_general',
	OCCUPATIONAL_THERAPY_EDU: 'occupational_therapy_edu',

	RAD_TECH_GENERAL: 'rad_tech_general',
	RAD_TECH_EDU: 'rad_tech_edu',
	RAD_TECH_CONTACT: 'rad_tech_contact',

	RESPIRATORY_THERAPIST_GENERAL: 'respiratory_therapist_general',
	RESPIRATORY_THERAPIST_EDU: 'respiratory_therapist_edu',
	RESPIRATORY_THERAPIST_CONTACT: 'respiratory_therapist_contact',

	VET_GENERAL: 'vet_general',
	VET_EDU: 'vet_edu',
	VET_CONTACT: 'vet_contact',

	OTHER_GENERAL: 'other_general',
	OTHER_EDU: 'other_edu',
	OTHER_CONTACT: 'other_contact',
}

export const USER_FORM_STATUS = {
	COMPLETED: 'completed',
}

export const FORMIK_DEBOUNCE_TIME = 500
export const FIELD_DEBOUNCE_TIME = 100
export const COMMON_DEBOUNCE_TIME = 1000
